var render, staticRenderFns
import script from "./productLevel.vue?vue&type=script&lang=js"
export * from "./productLevel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/jenkins/workspace/web-page/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('57071379')) {
      api.createRecord('57071379', component.options)
    } else {
      api.reload('57071379', component.options)
    }
    
  }
}
component.options.__file = "found/views/mdm/views/customer_information/components/extended_info/productLevel/productLevel.vue"
export default component.exports